export default "__VITE_ASSET__d21ce4a4__"